import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS, Pin } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const resultText = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.RESULT_TEXT> =>
	createModel({
		type: COMPONENT_TYPE.RESULT_TEXT,
		editorProps: {
			draggable: false,
		},
		componentProps: {
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						left: '1.17vw',
						top: '-2.19vw',
						right: 'auto',
						bottom: 'auto',
					},
				},
			},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						pinType: Pin.lb,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.RESULT_TEXT>;
